export default {
  data() {
    return {
      thumbImage: {
        switch: false,
        search: '',
        page: 1,
        loaded: false,
        errors: [],
      },
    }
  },
  computed: {
    thumbImages: function () {
      return this.$store.getters['image/filteredItems']({
        searchText: this.thumbImage.search,
        page: this.thumbImage.page,
      })
    },
    thumbImageNextCount: function () {
      const imageCount = this.thumbImages.count - this.thumbImages.data.length
      return imageCount > 6 ? 6 : imageCount
    },
  },
  methods: {
    onNextThumbImagesClick() {
      this.thumbImage.page += 1
    },
    onThumbImageSwitchChange(checked) {
      if (checked && !this.thumbImage.loaded) {
        this.loading = true
        this.$store.dispatch('image/getList')
          .catch(() => {})
          .finally(() => {
            this.loading = false
            this.thumbImage.loaded = true
          })
      }
    },
  },
}
